module.exports = __webpack_public_path__ + "static/media/pix.1d17b61e.png";